import React, { ChangeEvent, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import '../App.css';

import PageLoader from '../components/PageLoader';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import _ from 'lodash';
import Back from '../components/backComponent';
import GooglePlacesAutocomplete, { geocodeByAddress  } from 'react-google-places-autocomplete';

import Auth from '../core/services/auth';

function CreateVendor() {
  
    const navigate = useNavigate();
    const inputLogoRef = useRef<HTMLInputElement>(null)
    const [ name, setDisplayName ] = useState('')
    const [ website, setWebsite ] = useState('')
    const [ email, setEmail ] = useState('')
    const [ description, setDescription ] = useState('')
    const [ logo, setLogo ] = useState<File | null>()

    const [value, setValue] = useState<any>();

    // const handleLogoClick = useCallback(() => inputLogoRef.current?.click(), [])
    function handleLogoClick (e: any) {
        // console.log(e)

        inputLogoRef.current?.click()
    }


    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setLogo(event.target.files[0])
        }
    }
    

    const [ loading, setLoading ] = useState(false)

    const handleSubmit = (event: any) => {
      
        event.preventDefault();
        
        console.log('submitted');
        console.log(name)

        setLoading(true)
        
        // console.log(code)
        // const name = fullname.split(' ')

        const location = {
            "type": "Point",
            "coordinates": [0, 0],
            "name": value.label
        };
    
          //
        // console.log(value)
        geocodeByAddress(value.label).then(res=>{
            // console.log(res)
            location.coordinates = [ res[0].geometry.location.lat(), res[0].geometry.location.lng()]

            //  set form data
            const formData = {
                name: name,
                website: website,
                email: email,
                description: description,
                logo: logo,
                UserId: '',
                location: location
            }

            Auth.createVendorAccount(formData).then(res=>{
            
                setLoading(true)
    
                console.log(res.data)
                
                toast.success(res.data.message, {
                position: "top-center",
                });

                //  setup vendor
                Auth.setVendor(res.data.data)
    
                setTimeout(()=>{
                    // navigate 
                    navigate('/vendor', { state: { name: name } })
                }, 1800)
    
    
            }).catch(err=>{
        
                console.log(err)
        
                setLoading(false)

                // setTimeout(()=>{
                //   // navigate 
                //   navigate('/verify-password', { state: { email: email, otp: code } })
                // }, 1800)

                if (typeof(err.response) !== "undefined") {
                    if (err.response.data && _.isArray(err.response.data.error)) {
                        let error = err.response.data.error
                        //
                        for (let index = 0; index < error.length; index++) {
                        const err = error[index];
                        toast.error(err.message, {
                            position: "top-center",
                        });
                        }
                    } else {
                        toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
                        position: "top-center",
                        });
                    }
                }
                
        
            })

        })
        // if (!/\S+@\S+\.\S+/.test(email)) {
        //   setEmailError("Please enter your email")
  
        //   return
        // }
  
        // if ('' === password) {
        //   setPasswordError('Please enter a password')
  
        //   return
        // }
  
        // if (password.length < 7) {
        //   setPasswordError('password must be 8 characters or longer')
  
        //   return
        // }
  
        // e.preventDefault()
    
      } 

    return (
        <div className='dark:bg-gray-800 dark:text-white'>
            <Back title='Account'/>
            <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-[95vh] md:h-screen lg:py-0">
                { loading ? <PageLoader /> : '' }
                <ToastContainer />
                <AppLogo />
                <AppTitle title={'Vendor Signup'} description={'Discover places & events'} />

                <div className="w-full md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 mt-5">
                <div className="p- space-y-4 md:space-y-6 sm:p-8">
                    {/* <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                        Sign in to your account
                    </h1> */}
                    <form className="space-y-4 md:space-y-5" onSubmit={handleSubmit}>
                        <div>
                            <input type="text" minLength={3} name="name" id="name" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDisplayName(e.target.value) } placeholder="Name" value={name} required={true}/>
                            
                        </div>
                        <div className='grid grid-cols-2 gap-4'>
                                <div>
                                    <input type="text" name="website" id="website" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setWebsite(e.target.value) } placeholder="Website" value={website} required={false}/>
                                </div>
                                <div>
                                    <div className="relative ">
                                        <button type='button' onClick={handleLogoClick} className="absolute z-20 inset-y-0 end-0 flex items-center px-5 ">
                                            
                                            <svg className="w-7 h-7 text-dark dark:text-gray-400" focusable="false" aria-hidden="true" viewBox="0 0 24 24" >
                                                <circle cx="12" cy="12" r="3.2"></circle>
                                                <path d="M9 2 7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"></path>
                                            </svg>
                                        </button>
                                        <input type="text" id="logoText" disabled={true} className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 z-10 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={logo ? logo.name : 'Select Logo'}/>
                                    </div>

                                    {/* {logo && <p className='text-xs font-medium'>{logo.name}</p>} */}
                                </div>
                        </div>
                        <div className='text-left'>
                          <GooglePlacesAutocomplete 
                              apiKey='AIzaSyDIz3QGrrutmfxrRrYG7j4HAQ0By581Tgs'
                              selectProps={{
                                value: value,
                                onChange: setValue,
                                placeholder: 'Search Location...',
                                styles: {
                                  input: (provided) => ({
                                    ...provided,
                                    // display: 'block',
                                    // paddingTop: '1rem',
                                    // paddingBottom: '1rem', 
                                    // paddingLeft: '1.25rem',
                                    // paddingRight: '1.25rem',
                                    // borderRadius: '0.5rem',
                                    // width: '100%',
                                    // color: '#111827',
                                    // backgroundColor: '#F9FAFB',
                                    // borderColor: '0'
                                  })
                                }
                              }}
                          />
                        </div>
                        <div>
                            <input type="email" name="email" id="email" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setEmail(e.target.value) } placeholder="Email" value={email}/>
                        </div>
                        <div>
                            <input type="text" name="description" id="description" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setDescription(e.target.value) } placeholder="Description" value={description} required={true}/>
                        </div>
                        <div className='flex flex-col space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Create Account</button>
                            
                        </div>
                        {/* file input */}
                        <input ref={inputLogoRef} accept='image/*' type="file" name="logo" id="logo" className="invisible bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ handleFileChange } placeholder="Logo" required={false}/>
                    </form>
                </div>
                </div>
            </div>

        </div>
    )
}

export default CreateVendor